/** Traductions barcodeScanner (FR / AR) — shared scan strings + UI chrome */
import { barcodeScanSharedFr, barcodeScanSharedAr } from './barcodeScanShared';

export const barcodeScannerFr = {
  scannerCodeBarres: 'Scanner de Code-Barres',
  traitementRapide: 'Traitement rapide...',
  toujoursConnectePretScanner: 'Toujours connecté - Prêt à scanner',
  entrezCodeManuellementOuUtilisez: 'Entrez le code manuellement ou utilisez le scanner',
  rechercher: 'Rechercher',
  nom: 'Nom',
  sku: 'SKU',
  prix: 'Prix',
  correspondancesPotentielles: 'Correspondances potentielles',
  panier: 'Panier',
  elements: 'éléments',
  panierVide: 'Panier vide',
  utilisezScannerOuEntrezCode: 'Utilisez le scanner ou entrez le code manuellement',
  lot: 'Lot',
  total: 'Total',
  reinitialiser: 'Réinitialiser',
  ajouterPanier: 'Ajouter au panier',
  doneLive: 'Terminé',
  liveCartHint: 'Ajout direct au panier de caisse (lots inclus)',
  catalogTitle: 'Produits disponibles',
  loadingCatalog: 'Chargement des produits…',
  noCatalog: barcodeScanSharedFr.noInStockList,
  productsLoaded: '{{count}} produits chargés',
  tapToAdd: 'Scannez, tapez ou touchez une ligne pour ajouter',
  codeBarres: 'Code-barres',
  stock: 'Stock',
  filterResults: '{{count}} résultat(s) pour « {{query}} »',
  noFilterResults: 'Aucun produit ne correspond à la recherche',
  productOutOfStock: barcodeScanSharedFr.outOfStock,
  barcodeNotFound: barcodeScanSharedFr.notFoundType,
  codeTooShort: barcodeScanSharedFr.codeTooShort,
  skuNotFound: barcodeScanSharedFr.skuNotFound,
  productAdded: barcodeScanSharedFr.productAdded,
  productExpired: barcodeScanSharedFr.productExpired,
  ambiguousBarcode: barcodeScanSharedFr.ambiguousPick,
  codeTooLong: barcodeScanSharedFr.codeTooLong,
  codeCleanFailed: barcodeScanSharedFr.codeCleanFailed,
  productNotFound: barcodeScanSharedFr.productNotFound,
  networkError: barcodeScanSharedFr.networkError,
  permissionDenied: barcodeScanSharedFr.permissionDenied,
  processingError: barcodeScanSharedFr.processingError,
  close: 'Fermer'
};

export const barcodeScannerAr = {
  scannerCodeBarres: 'ماسح الكود الشريطي',
  traitementRapide: 'معالجة سريعة...',
  toujoursConnectePretScanner: 'متصل دائماً - جاهز للمسح',
  entrezCodeManuellementOuUtilisez: 'أدخل الكود يدوياً أو استخدم الماسح',
  rechercher: 'بحث',
  nom: 'الاسم',
  sku: 'SKU',
  prix: 'السعر',
  correspondancesPotentielles: 'التطابقات المحتملة',
  panier: 'السلة',
  elements: 'عنصر',
  panierVide: 'السلة فارغة',
  utilisezScannerOuEntrezCode: 'استخدم الماسح أو أدخل الكود يدوياً',
  lot: 'اللوتات',
  total: 'المجموع',
  reinitialiser: 'إعادة تعيين',
  ajouterPanier: 'إضافة للسلة الرئيسية',
  doneLive: 'تم',
  liveCartHint: 'إضافة مباشرة لسلة الكاشير (مع اللوتات)',
  catalogTitle: 'المنتجات المتاحة',
  loadingCatalog: 'جاري تحميل المنتجات…',
  noCatalog: barcodeScanSharedAr.noInStockList,
  productsLoaded: '{{count}} منتج محمّل',
  tapToAdd: 'امسح أو اكتب أو المس سطراً للإضافة',
  codeBarres: 'الباركود',
  stock: 'المخزون',
  filterResults: '{{count}} نتيجة لـ « {{query}} »',
  noFilterResults: 'لا منتجات تطابق البحث',
  productOutOfStock: barcodeScanSharedAr.outOfStock,
  barcodeNotFound: barcodeScanSharedAr.notFoundType,
  codeTooShort: barcodeScanSharedAr.codeTooShort,
  skuNotFound: barcodeScanSharedAr.skuNotFound,
  productAdded: barcodeScanSharedAr.productAdded,
  productExpired: barcodeScanSharedAr.productExpired,
  ambiguousBarcode: barcodeScanSharedAr.ambiguousPick,
  codeTooLong: barcodeScanSharedAr.codeTooLong,
  codeCleanFailed: barcodeScanSharedAr.codeCleanFailed,
  productNotFound: barcodeScanSharedAr.productNotFound,
  networkError: barcodeScanSharedAr.networkError,
  permissionDenied: barcodeScanSharedAr.permissionDenied,
  processingError: barcodeScanSharedAr.processingError,
  close: 'إغلاق'
};
